import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWheelchairNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8 8c3.609 0 6.66 2.39 7.656 5.673l5.305 1.719-.633-2.892H18V10h2.529a2.25 2.25 0 012.198 1.768l.505 2.308a5.5 5.5 0 11-2.213 3.963l-5.03-1.63A8 8 0 118 8zm-5.5 8a5.5 5.5 0 0010.997.175L7.02 17.471l-.49-2.452 6.48-1.295A5.501 5.501 0 002.5 16zm21.02 2.849a3 3 0 10.77-2.379l3.784 1.226-.77 2.378z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWheelchairNormalMedium;
